<div class="partner-container hide-on-print">
  <div class="clr-row clr-justify-content-center">
    <div class="clr-col-lg-8 clr-col-md-10 clr-col-sm-12">
      <app-profile-picture [userId]="partnerId"></app-profile-picture>
      <h4>{{__('broughtToYouBy')}} {{partnerName}}</h4>
    </div>
  </div>
</div>
